export default __webpack_public_path__ + "static/media/HomepageEarnCard.489d2bd4.png";